export default function(compareValue, cellValue) {
  const compareValueStr = String(compareValue)
  const cellValueStr = String(cellValue)
  return compareValueStr.localeCompare(cellValueStr.toLowerCase(), 'de', { numeric: true })
}
